import { chain } from "lodash";

interface WithCustomer {
  customerId: number;
}

/**
 * Returns an array of numbers from 1 to the specified length.
 *
 * @example
 * getSequenceArray(5); // [1, 2, 3, 4, 5]
 */
export const getSequenceArray = (length: number): number[] => {
  return Array.from({ length }, (_, index) => index + 1);
};

export const withConfirmation = (
  callback: () => void,
  message: string = "Are you sure?",
) => {
  if (window.confirm(message)) {
    callback();
  }
};

export const preordersToAlertsCount = (orders: WithCustomer[]) =>
  chain(orders)
    .groupBy("customerId")
    .mapValues((val) => val?.length || 0)
    .value();
